import { render } from "./LIcon.vue?vue&type=template&id=0e57c74a"
import script from "./LIcon.vue?vue&type=script&lang=js"
export * from "./LIcon.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__